import { shouldPolyfill } from "@formatjs/intl-numberformat/should-polyfill";
import type { ReactNode } from "react";
import { useEffect, useState } from "react";

import type { Money as MoneyObject } from "../../graphql/types";
import { Money } from "../Money";

export type PriceChildren = MoneyObject | string | ReactNode;

export interface ItemPriceProps {
  children: PriceChildren;
}

export function ItemPrice({ children }: ItemPriceProps) {
  const [isLocaleLoaded, setIsLocaleLoaded] = useState(false);

  const locale = Intl.DateTimeFormat().resolvedOptions().locale;

  useEffect(() => {
    const unsupportedLocale = shouldPolyfill(locale);

    async function polyfillNumberFormat() {
      if (unsupportedLocale) {
        await import("@formatjs/intl-numberformat/polyfill-force");
        await import(
          `@formatjs/intl-numberformat/locale-data/${unsupportedLocale}`
        );
      }

      setIsLocaleLoaded(true);
    }
    polyfillNumberFormat();
  }, [locale]);

  return isLocaleLoaded ? (
    <span className="item--price" data-test-id="item-price">
      {typeof children === "object" && children && "amount" in children ? (
        <Money>{children}</Money>
      ) : (
        children
      )}
    </span>
  ) : null;
}
